/* eslint-disable */
<template>
  <div class="vue-datatables">
    <div class="row mb-3" v-if="tconfig.cfilters && !readonly">
      <div class="col" v-for="option in tcfilters" v-if="option.count">
        <div class="bg-white p-2 rounded shadow cursor-pointer d-flex justify-content-between align-items-center"
             :class="{'border border-color-1' : selectedCustomFilter == option.key}"
             @click="doCustomFilter(tconfig.cfilters.name ,option.key)">
          <span class="text-capitalize">{{ option.value ? option.value : option.key }} ({{ option.count }})</span>
          <div class="d-flex align-items-center">
            <img src="@/assets/filter.png" alt="">
          </div>
        </div>
      </div>
    </div>


    <!-- Statuses filters -->
    <div class="row mb-3 flex-wrap" v-if="this.$route.name !== 'leads' && this.$route.name !== 'personalDashboard'">
      <div class="col-auto mb-2" v-for="status in statusesFilter" v-if="status.count">
        <div class="bg-white p-1 rounded shadow cursor-pointer d-flex justify-content-between align-items-center"
             :class="{'border' : status_id == status.key,[status.key]:true}"
             :style="{'border-color' : status_id == status.key ? status.color + '!important' : ''}"
             @click="status_id = status.key; filterInsuranceCompany($event, $route.name);">
          <span class="text-capitalize">{{ status.value }} ({{ status.count }})</span>

        </div>
        <div v-if="status_id != status.key" class="border-bottom-3 mt-1" :style="{'color' : status.color }"></div>
      </div>
    </div>

    <!-- Browse Through Orders -->
    <button v-if="previewOrderList.length > 0" @click="openOrderModal" data-toggle="modal" data-target="#ordersModal"
            class="btn border btn-sm ">
      {{$t('orders.browseThroughOrders')}}
    </button>

    <!-- Multi messages -->
    <button v-if="previewOrderList.length > 0"  @click="openOrderModal" data-toggle="modal" data-target="#messagesModel"
            class="btn border btn-sm ">
      {{$t('orders.newMsg')}}
    </button>

    <div v-if="(isAdmin || isManagement) &&  previewOrderList.length > 0"  class="btn-group dropleft py-2 mx-1" role="group">
<!--      <button class="border border-gray-2 position-relative bg-success" data-toggle="modal" data-target="#whatsappMessagesModel">-->


      <button class="btn btn-sm btn-success position-relative" @click="() => openCampaignModal('whatsappCampaign')">
        <span class="text-white">הודעות וואטסאפ קבוצתיות</span>
      </button>

      <button class="btn btn-sm btn-primary position-relative mx-1" @click="() => openCampaignModal('smsCampaign')">
        <span class="text-white">הודעות SMS קבוצתיות</span>
      </button>

      <button class="btn btn-sm btn-primary position-relative" @click="() => openCampaignModal('mailCampaign')">
        <span class="text-white">הודעות Mail קבוצתיות</span>
      </button>

      <button class="btn btn-sm btn-success position-relative mx-1" @click="() => openCampaignStatusesModal(true)">
        <span class="text-white">עדכון סטטוס קבוצתי</span>
      </button>
    </div>


    <!-- Order Modal -->
    <div class="modal fade" id="ordersModal">
      <div class="modal-dialog">
        <div class="modal-content" style="width: 1200px">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title w-100">{{$t('orders.browseThroughOrders')}}</h4>
            <button type="button" class="close" data-dismiss="modal" @click="cleanModelCheck">&times;</button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
              <div class="carousel-inner">
                <div v-for="(value,key) in ordersPreviewUrl" :id="`order-preview-${key}`" class="carousel-item">
                  <iframe :src="value" class="d-block w-100" width="1200px" height="600px"></iframe>
                </div>
              </div>
            </div>
          </div>

          <!-- Modal footer -->
          <div class="modal-footer justify-content-center">
            <!-- Arrow Right -->
            <a href="#carouselExampleControls" data-slide="next" class="m-2">
              <button>
                <i class="fa fa-arrow-right"></i>
              </button>
            </a>

            <!-- Arrow Left -->
            <a href="#carouselExampleControls" data-slide="prev">
              <button>
                <i class="fa fa-arrow-left"></i>
              </button>
            </a>
          </div>

          <!--<a class="" href="#carouselExampleControls" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="" href="#carouselExampleControls" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>-->

        </div>
      </div>
    </div>

    <!-- Messages Modal -->
    <div class="modal fade" id="messagesModel">
      <div class="modal-dialog">
        <div class="modal-content" style="width: 1200px">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title w-100">{{$t('orders.messages')}}</h4>
            <button type="button" class="close" data-dismiss="modal" @click="cleanModelCheck">&times;</button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <div class="carousel slide" data-ride="carousel">
              <div class="carousel-inner">
                <label for="msgType" class="sr-only">{{$t('orders.newMsg')}}</label>
                <div class="col-md-3 pr-0">
                  <!-- Choose message type -->
                  <select class="form-control" id="msgType" ref="msgType" @change="requestMsg()">
                    <option selected disabled>{{$t('orders.msgType')}}</option>
                    <option>הודעה חדשה</option>
                    <option v-for="msg in tconfig.options.messages"
                            :value="msg.id">
                      {{msg.displayName}}
                    </option>
                  </select>
                </div>
                <template v-if="!dataTableReady">
                  <form @submit.prevent="sendMsg" class=" mb-2">
                    <div class="row py-3 ">
                      <!-- Message Id -->
                      <formControl
                        type="hidden"
                        name="messageId"
                        id="messageId"
                        :val="$route.query.id"
                        v-model="msg.messageId">
                      </formControl>
                      <!-- Message PhoneBook -->
                      <div class="col-lg-4" v-if="msg.autoSend === 0">
                        <label class="mb-0">{{$t('orders.address')}}</label>
                        <!--<small>{{$t('orders.addressNotSelected')}}</small>-->
                        <multiselect
                          id="address"
                          v-model="msg.phoneBookAddress"
                          :options="tconfig.options.phoneBook"
                          label="fullName"
                          track-by="fullName"
                          :multiple="true"
                          :placeholder="$t('orders.selectContact')"
                          :selectLabel="$t('orders.select')"
                          :deselectLabel="$t('orders.remove')"
                        />
                      </div>
                      <!-- second email -->
                      <formControl v-if="msg.autoSend === 0" :label="$t('orders.secondMailAddress')"
                                   type="text"
                                   name="secondMailAddress"
                                   id="secondMailAddress"
                                   class="col-lg-4"
                                   :val="msg.secondMailAddress"
                                   v-model="msg.secondMailAddress">
                      </formControl>
                      <!-- Message Subject -->
                      <formControl v-if="msg.autoSend !== 3" :label="$t('orders.subject')"
                                   type="text"
                                   name="subject"
                                   id="msgSubject"
                                   class="col-lg-4"
                                   :val="msg.subject"
                                   v-model="msg.subject"
                                   :readOnly="msg.isEditable">
                      </formControl>
                      <formControl v-if="msg.autoSend === 3" :label="$t('tables.headers.smsPhoneNumber')"
                                   type="tel"
                                   name="smsPhoneNumber"
                                   id="msgSmsPhoneNumber"
                                   class="col-lg-4"
                                   :val="msg.smsPhoneNumber"
                                   v-model="msg.smsPhoneNumber"
                                   :readOnly="msg.isEditable">
                      </formControl>
                    </div>
                    <!-- Message body -->
                    <formControl v-if="msg.autoSend !== 3" :label="$t('orders.body')"
                                 type="textarea"
                                 name="body"
                                 rows="4"
                                 id="body"
                                 class="mb-2"
                                 :val="msg.content"
                                 v-model="msg.content"
                                 :readOnly="msg.isEditable"
                    />

                    <formControl v-if="msg.autoSend === 3" label="גוף הודעת טקסט"
                                 type="textarea"
                                 name="body"
                                 rows="4"
                                 id="smsBody"
                                 class="mb-2"
                                 :val="msg.smsContent"
                                 v-model="msg.smsContent"
                                 :readOnly="msg.isEditable"
                                 :maxlength="'130'"

                    />
                    <!-- Message replayTo -->
                    <formControl :label="$t('tables.headers.replayTo')"
                                 type="email"
                                 name="replayTo"
                                 rows="4"
                                 id="replayTo"
                                 class="mb-2"
                                 :val="msg.replayTo"
                                 v-model="msg.replayTo"
                    />
                    <button type="submit" class="btn btn-color-1">
                      {{$t('orders.submit')}}
                    </button>
                  </form>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CampaignMessages
      ref="campaignMessagesModel"
      id="campaignMessagesModel"
      :messages=campaignMessages
      :rows=rows
      :campaignKind=campaignKind
      :previewOrderList=previewOrderList
      model="Order"

    />
    <CampaignStatuses v-if="openStatusCampaign"
      ref="campaignStatusesModel"
      id="campaignStatusesModel"
      :tconfig=tconfig
      :statuses=campaignStatuses
      :previewOrderList=previewOrderList
      :routhName=$route.name
      @addNoteAfterStatusUpdate="addNoteAfterStatusUpdate"
      model="Order"
    />


    <div class="bg-white p-2 rounded shadow pt-4 position-relative pt-3">
      <div class="pos-t-1 pos-l-2 input-container" v-if="!readonly">
        <div class="d-flex flex-wrap input-box ">

          <!-- Hova and Second Company Search-->
          <div @keyup="searchHoveAndSecondCompany" class="ml-1" :ref="searchHoveAndSecondCompany" >
            <input class="form-control" type="text" placeholder="חיפוש חובה ורכוש" value="" id="searchHoveAndSecondCompany">
          </div>
          <!--<select class="ml-1 custom-select" v-if="this.$route.name ==='orders'" ref="hovaSecondCompany" name="hovaSecondCompany"
                  @change="filterInsuranceCompany($event, 'protectiveStatus')">
            <option :value="'all'">סטטוס מיגון</option>
            <option v-for="option in tconfig.options['protectionStatus']" :value="option.key">
              {{option.value}} ({{option.count}})
            </option>
          </select>-->
          <!-- Payment Status Filter-->
          <select class="ml-1 custom-select" v-if="routePartOfOrdersGroup()" ref="paymentStatus" name="paymentStatus"
                  @change="filterInsuranceCompany($event, 'paymentStatus')">
            <option :value="'all'">סטטוס גביה</option>
            <option v-for="option in tconfig.options['paymentStatus']" :value="option.key">
              {{option.value}} ({{option.count}})
            </option>
          </select>

          <!-- Policy Status Filter-->
          <select class="ml-1 custom-select" v-if="routePartOfOrdersGroup()" ref="policyStatus" name="policyStatus"
                  @change="filterInsuranceCompany($event, 'policyStatus')">
            <option :value="'all'">סטטוס פוליסה</option>
            <option v-for="option in tconfig.options['policyStatus']" :value="option.key">
              {{option.value}} ({{option.count}})
            </option>
          </select>

          <!-- Changes Status Filter-->
          <select class="ml-1 custom-select" v-if="routePartOfOrdersGroup()" ref="changesStatus" name="changesStatus"
                  @change="filterInsuranceCompany($event, 'changesStatus')">
            <option :value="'all'">סטטוס שינויים</option>
            <option v-for="option in tconfig.options['changesStatus']" :value="option.key">
              {{option.value}} ({{option.count}})
            </option>
          </select>

          <!-- Claims Status Filter-->
          <select class="ml-1 custom-select" v-if="routePartOfOrdersGroup()" ref="claimsStatus" name="claimsStatus"
                  @change="filterInsuranceCompany($event, 'claimsStatus')">
            <option :value="'all'"> סטטוס תביעות</option>
            <option v-for="option in tconfig.options['claimsStatus']" :value="option.key">
              {{option.value}} ({{option.count}})
            </option>
          </select>

          <!-- Protective Status Filter-->
          <select class="ml-1 custom-select" v-if="routePartOfOrdersGroup()" ref="protectiveStatus" name="protectiveStatus"
                  @change="filterInsuranceCompany($event, 'protectiveStatus')">
            <option :value="'all'">סטטוס מיגון</option>
            <option v-for="option in tconfig.options['protectionStatus']" :value="option.key">
              {{option.value}} ({{option.count}})
            </option>
          </select>

          <!-- lackOfClaims Status Filter-->
          <select class="ml-1 custom-select" v-if="routePartOfOrdersGroup()" ref="lackOfClaims" name="lackOfClaims"
                  @change="filterInsuranceCompany($event, 'lackOfClaims')">
            <option :value="'all'">{{$t('tables.headers.lackOfClaimsStatus')}}</option>
            <option v-for="option in tconfig.options['lackOfClaims']" :value="option.key">
              {{option.value}} ({{option.count}})
            </option>
          </select>

          <!-- Ins type filter -->
          <select class="ml-1 custom-select" v-if="routePartOfOrdersGroup()" ref="insTypeStatus" name="insTypeStatus"
                  @change="filterInsuranceCompany($event, 'insTypeStatus')">>
            <option :value="'all'">{{$t('tables.headers.ins-type')}}</option>
            <option v-for="option in insType" :value="option.key">
              {{option.value}}
            </option>
          </select>


          <!-- Companies filter -->
          <select class="ml-1 custom-select" v-if="routePartOfOrdersGroup()" ref="companiesStatus" name="companiesStatus"
                  @change="filterInsuranceCompany($event, 'companiesStatus')">>
            <option :value="'all'">{{$t('tables.headers.insuranceCompany')}}</option>
            <option v-for="option in companiesList" :value="option.value">
              {{option.value}}
            </option>
          </select>

          <input class="form-control" type="text" v-if="routePartOfOrdersGroup()" placeholder="חיפוש בבסיס נתונים" v-model="search_in_db" autocomplete="off">

          <button v-if="routePartOfOrdersGroup()" class="btn border btn-sm" @click="filterInsuranceCompany($event, 'dbSearch')">חפש</button>

          <!-- Leads Status Filter-->
          <select class="ml-1 custom-select" v-if="this.$route.name ==='leads'" ref="leadsStatuses" name="leadsStatuses"
                  @change="filterLeadsStatuses">
            <option :value="'all'">{{$t('orders.statuses')}}</option>
            <option v-for="option in tconfig.options['statuses']" v-if="option.statusGroup == tconfig.statusGroup"
                    :value="option.key">
              {{option.value}}
            </option>
          </select>

          <!-- Clean Filter Button-->
          <button @click="cleanFilters" class="btn border btn-sm ">{{$t('message.cleanFilter')}}</button>

          <button @click="newRow = !newRow" v-if="!tconfig.readonly && tconfig.addNewRow !== false"
                  class="border border-gray-2 rounded-circle position-relative p-2 mr-1 bg-white">
            <span class="text-p xy-align" :class="[newRow ? 'icon-minus' : 'icon-plus']"></span>
          </button>

          <!-- Print Button -->
          <button @click="print()"
                  class="border border-gray-2 rounded-circle position-relative p-2 mr-1 bg-white">
            <span class="icon-print text-p xy-align"></span>
          </button>

          <input type="file" ref="file" style="display: none" @change="uploadCsv($event)">
          <button v-if="tconfig.enableCsvUpload" @click="$refs.file.click()"
                  class="border border-gray-2 rounded-circle position-relative p-2 mr-1 bg-white">
            <span class="icon-upload text-p xy-align"></span>
          </button>

          <!-- Download excel-->
          <div v-if="isAdmin || isManagement" class="btn-group dropleft" role="group">
            <button id="downloadBtnGroup" type="button"
                    class="border border-gray-2 rounded-circle position-relative p-2 mr-1 bg-white"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

              <span class="icon-download text-p xy-align"></span>
            </button>
            <div class="dropdown-menu" aria-labelledby="downloadBtnGroup">
              <a class="dropdown-item" href="#" @click="downloadExcel($route.name+'.csv')">
                Download Excel
                <!--<download-excel :data="rows">
                  Download Excel
                </download-excel>-->
              </a>
            </div>
          </div>
        </div>
      </div>



      <div class="mb-3" v-if="title"><h2>{{title}}</h2></div>
      <template v-html="translateById(props.row[item.color], options)"></template>

      <!-- Loader -->
      <template v-if="dataTableReady">
        <loader/>
      </template>

      <!-- ADD NEW MESSAGE OUTSIDE TABLE -->
      <addNewMessage v-if="newRow && $route.name === 'messages'" />

      <!-- ADD NEW ROW FOR OTHER TABLES -->
      <div v-else-if="newRow" class="row mb-3">
        <form @submit.prevent="addNewRow" class="row" autocomplete="off" style="width: 100%">
          <div class="col-lg-4" v-for="item in tconfig.schema">
            <formControl :label="$t('tables.headers.' + item.name)"
                         :type="item.type"
                         :name="item.name"
                         v-validate="item.validation"
                         v-model="newRowData[item.name]"
                         :error="errors.first(item.name)"
                         :val="item.value"
                         :options="tconfig.options[item.options] ? tconfig.options[item.options] : item.options"
            />
          </div>
          <div class="col-lg-4 d-flex align-items-end mb-2 mt-4">
            <button type="submit" class="btn btn-color-1 w-100">
              <span>Add</span>
            </button>
          </div>
        </form>
      </div>


      <v-client-table :data="rows" :columns="columns" :options="options" @pagination="closeRowEdit"
                      @sorted="closeRowEdit"
                      ref="table" v-show="!dataTableReady">

        <!-- TABLE CONTROLLERS -->
        <div slot="beforeLimit" v-if="!readonly">
          <div class="d-flex justify-content-between ml-2">


            <!--<button type="button" class="btn btn-secondary"-->
            <!--@click="handleFilter">{{$t('message.FilterByColumn')}}-->
            <!--</button>-->

            <div v-if="!tconfig.hideDateFilter" class="input-group">
              <input class="form-control"
                     type="text"
                     :placeholder="$t('message.dateFilter')"
                     name="daterange"
                     @focus="openDateRange">
              <div class="input-group-append">
                <button class="btn btn-danger" type="button" v-if="dateFilter"
                        @click="clearDateFilter()">
                  {{$t('message.clean')}}
                </button>
                <div v-else
                     class="input-group-text px-1 d-flex justify-content-center align-items-center">
                  <span class="icon-calendar"></span>

                </div>
              </div>
            </div>
          </div>
        </div>


        <!-- SELECT ROW -->
        <!--<template slot="h__select">-->
        <!--<input type="checkbox" @click='selectAll($event)'>-->
        <!--</template>-->

        <!--<template slot-scope="props" slot="select">-->
        <!--<input type="checkbox" v-model="checked" :value="props.row.id">-->
        <!--</template>-->


        <!--<template slot-scope="props" slot="#">-->
        <!--<span :ref="`oi_${props.index}`">{{props.index}}</span>-->
        <!--</template>-->

        <!-- SLOTS FIELDS EDIT -->
        <template v-for="(item, k) in tcols" :slot="'h__' + item">
          <span>{{$t('tables.headers.' + item)}}</span>
          <input v-if="k === 0 " type="checkbox"  name="selectAll" v-model="rolesSelected" class="align-self-center" @click='selectAll($event)' />
        </template>

        <!-- SLOTS FIELDS EDIT -->
        <template slot-scope="props" v-for="(item, i) in tconfig.schema" :slot="item.name">
          <div class="td-wrapper" :ref="props.row.id+'_'+item.name">
            <template v-if="item.options">
              <div v-html="translateById(props.row[item.name], item.options)"></div>
            </template>

            <span v-else>
              <span
                :style="{'color' : $route.name === 'statuses' && item.name === 'color' ? props.row['color'] + '!important' : ''}">{{props.row[item.name]}}</span>
            </span>

            <formControl v-if="item.editable"
                         :type="item.type"
                         :name="item.name"
                         :id="`${item.name}_${props.row.id}`"
                         classes="mb-0"
                         class="d-none mb-0"
                         v-validate="item.validation"
                         v-model="props.row[item.name]"
                         :options="getFieldOptions(item.options)"
                         :error="errors.first(item.name)"
                         :val="props.row[item.name]"
            />
          </div>
        </template>


        <!--<template slot-scope="props" slot="statusId">-->
        <!--<div v-html="translateStatus(props.row.statusId)"></div>-->
        <!--</template>-->

        <!-- ROW ACTIONS -->
        <div class="d-flex justify-content-around h-100" slot="actions" slot-scope="props">

          <template v-if="inRowEdit === props.row.id" class="d-flex">
            <button class="btn btn-sm btn-color-1 rounded-0 w-50" @click="doneEdit(props.row)">
              <span>{{$t('message.ok')}}</span>
            </button>
            <button class="btn btn-sm btn-danger rounded-0 w-50" @click="cancelEdit(props.row)">
              <span>{{$t('message.cancel')}}</span>
            </button>
          </template>
          <template v-else>

            <RowActions
              :route="$route"
              :id="props.row.id ? 'preview-order-list'+'_'+props.row.id.toString() : ''"
              :value="props.row.id.toString()"
              @catchPreviewList="catchPreviewList"
              :phoneNumber="props.row['phone'] || props.row['mobile-phone-number']"
              :productSelectedRow="props.row"
            />
<!--            <input v-if="$route.name ==='orders' || $route.name ==='leads'" type="checkbox" name="preview-order-list" :id="'preview-order-list'+'_'+props.row.id" class="align-self-center"-->
<!--                   :value="props.row.id" @change="catchPreviewList(props.row['mobile-phone-number'])"/>-->

            <button v-if="checkActionsLimitations('edit')" class="btn btn-link px-1"
                    @click="edit(props.row)"><span
              class="icon icon-pencil icon-xs"></span></button>

            <button v-if="checkActionsLimitations('remove')" class="btn btn-link px-1"
                    @click="remove(props.row.id)"><span
              class="icon icon-trash icon-xs"></span></button>

            <router-link :to="`view?table=${getTableName()}&id=${props.row.id}`" target="_blank">
              <span class="icon icon-doublearrowleft"></span>
            </router-link>

            <!-- Resend order to hova's CRM (client request) -- admin-only, orders table only. -->
            <button v-if="$store.getters.isAdmin && routePartOfOrdersGroup()" class="btn btn-link px-1"
                    @click="resendOrderToHova(props.row)"><span
              class="icon icon-upload icon-xs"></span></button>

          </template>
        </div>

        <!-- ROW CHILD -->
        <!--<div slot="child_row" slot-scope="props">-->
        <!--The link to {{props.row.firstName}} is <a :href="props.row.uri">{{props.row.firstName}}</a>-->
        <!--</div>-->

      </v-client-table>

    </div>
  </div>
</template>


<script>

import {Event} from 'vue-tables-2'
import router from '../router'
import formControl from '@/components/formcontrol'
import Multiselect from 'vue-multiselect'
import axios from '../axios'
import _ from 'lodash'
import Swal from 'sweetalert2'
import loader from '@/components/loader'
import alert from "@/components/alert.vue";
import CampaignMessages from "@/views/Modal/campaignMessagesModel.vue";
import CampaignStatuses from "@/views/Modal/campaignStatusesModel.vue";
import RowActions from "@/components/rowActions.vue";
import helpers from "@/helpers";
import AddNewMessage from "@/templates/add-new-message.vue";

export default {
  props: ['tcols', 'trows', 'tconfig', 'readonly', 'title', 'rows_count', 'storageName'],
  components: {formControl, loader, Multiselect, CampaignMessages, CampaignStatuses, RowActions, AddNewMessage},
  mixins: [helpers],
  created() {
    this.status_id = +this.$route.query.statusId ||null;
    // if the agent return from order->single we show again the aside bar
    if ($('.aside-table').hasClass("d-none")) {
      $('.aside-table').removeClass('d-none')
    }
    if (this.$store.getters.isAdmin) {
      this.isAdmin = this.$store.getters.isAdmin;
    }
      if (this.$store.getters.isManagement) {
        this.isManagement = this.$store.getters.isManagement;
      }

      if (this.tconfig.cfilters) {
        let filterName = this.tconfig.cfilters.name
        let filter = new Object({
          name: filterName,
          callback: function (row, query) {
            return row[filterName] == query
          }
        })
        this.options.customFilters.push(filter)
      }
      // Statuses filters
      if (this.tcols.includes('statusId')) {
        let filter = new Object({
          name: 'statusId',
          callback: function (row, query) {
            return row['statusId'] == query
          }
        })
        this.options.customFilters.push(filter)

      }

      let options = this.tconfig.options;
      if (options) {
        for (let i in options) {
          if (i === 'statuses' && this.tconfig.statusGroup) {
            this[i] = this.setStatuses(options[i]);
            options.statuses = this[i];
          } else {
            this[i] = options[i]
          }
        }
      }

    },
    computed: {
      tcfilters() {
        return typeof this.tconfig.cfilters.options === 'object' ? this.tconfig.cfilters.options : this.tconfig.options[this.tconfig.cfilters.options]
      },
      max_page(){
        return Math.ceil(parseInt(this.rows_count) / 25);
      },
      pages_range(){
        let range_array = [];
        let page = parseInt(this.page_p);
        let max_page = this.max_page - 1;
        let last = 10;
        let start = 1;
        if(page !== 1){
          start = page - 1;
        }
        if((page + 9) < max_page){
          last = page + 9;
        }else{
          last = max_page;
        }

        for (let i = start; i <= last; i++){
          range_array.push(i);
        }

        console.log('range_array', range_array);

        return range_array;
      }
    },
    mounted() {

      const urlParams = new URLSearchParams(window.location.search)
      let url_p = parseInt(urlParams.get('page'));
      if(url_p) {
        this.page_p = url_p;
      }

      this.update_url_params(this.$route.query);

      /* Refresh orders page every 5 minutes*/
      if(location.href.indexOf('/orders') || location.href.indexOf('/leads')) {
        let interval = setInterval(function() {
          if(location.href.indexOf('/orders') === -1 && location.href.indexOf('/leads') === -1) {
            clearInterval(interval);
          }else{
            window.location.reload()
          }
          //
        }, 300000);
      }

      this.$watch(() => this.$refs.table.userColumnsDisplay, (val) => {
        let key = this.storageName ? `table_${this.storageName}_settings` : `table_${this.$route.name}_settings`;
        localStorage.setItem(key, val)
        if (this.inRowEdit) {
          this.cancelEdit(this.inRowEdit)
        }
      });

      this.$watch(() => this.$refs.table.page, (val) => {
        if (this.inRowEdit) {
          this.cancelEdit(this.inRowEdit)
        }
        this.updateUrl('tpage', val)
      })

      this.$watch(() => this.$refs.table.query, (val) => {
        this.updateUrl('tquery', val)
        this.options.filterBySearchBox = val;
      });

      this.$watch(() => this.$refs.table.currentlySorting, (val) => {
        this.updateUrl('tsortcolumn', [val.ascending, val.column])
      })

      if (this.$route.query.tcfilter) {
        let tcfilter = this.$route.query.tcfilter.split(',')
        this.doCustomFilter(tcfilter[0], tcfilter[1])
      }

      if (this.$route.query.date) {
        let dates = this.$route.query.date.split(',')
        this.getRecordsByDate(dates[0], dates[1])

        $('input[name="daterange"]').daterangepicker({
          startDate: new Date(dates[0]),
          endDate: new Date(dates[1]),
          locale: {
            format: 'DD/MM/YY',
            'firstDay': 0
          }
        })

        this.dateFilter = true
      }

      if(this.$route.query.hova_company) {

        $('#searchHoveAndSecondCompany').val(this.$route.query.hova_company)
       // this.$refs.searchHoveAndSecondCompany.value  = this.$route.query.hova_company;
        // start loader
        this.dataTableReady = true;
        let data = {
          name: this.$route.query.hova_company,
        };
        axios.post(`/${this.$route.name}/hovaSecondCompanyFilter`, data)
          .then((res) => {
            if (res.data.data.rows) {
              this.dataTableReady = false;
              this.rows = res.data.data.rows;
            } else {
              this.$parent.$emit('alert', 'danger', 'No rows found')
            }
          })
          .catch((err) => {
            this.dataTableReady = false;
            this.$parent.$emit('alert', 'danger', err.response.data.data.error)
          })
      }

      // append new row as a v-model
      for (let i in this.tconfig.schema) {
        this.newRowData[this.tconfig.schema[i].name] = ''
      }

      let key = this.storageName ? `table_${this.storageName}_settings` : `table_${this.$route.name}_settings`;
      let displayCols = localStorage.getItem(key);
      if (displayCols) {
        let displayColsToArr = _.split(displayCols, ',')
        this.$refs.table.userControlsColumns = true
        this.$refs.table.userColumnsDisplay = displayColsToArr
      } else if (this.tconfig.initDisplayCols) {
        this.$refs.table.userControlsColumns = false
        this.$refs.table.userColumnsDisplay = this.tconfig.initDisplayCols
      }
    },
    data: function () {
      return {
        status_id: '',
        search_in_db: '',
        page_p: 1,
        url_params: '',
        columns: this.tcols,
        rows: this.trows,
        dataTableReady: false,
        statusesFilter: [],
        campaignStatuses: [],
        options: {
          //https://stackoverflow.com/questions/48476910/vue-tables-2-perpagevalues-option-not-working-correctly
          perPageValues: [10, 25, 50, 100, 100000000],

          initialPage: this.$route.query.tpage,
          initFilters: this.$route.query.tquery ? {GENERIC: this.$route.query.tquery} : null,
          filterBySearchBox: '',
          orderBy: {
            ascending: this.$route.query.tsortcolumn ? this.getBool(this.$route.query.tsortcolumn.split(',')[0]) : '',
            column: this.$route.query.tsortcolumn ? this.$route.query.tsortcolumn.split(',')[1] : ''
          },
          columnsDropdown: this.$store.getters.isAdmin || this.$store.getters.isManagement ? !this.readonly : '',
          // filterByColumn: true,
          columnsDisplay: {},
          perPage: 50,
          texts: {
            count: `${this.$t('tables.general.display')} {from} ${this.$t('tables.general.to')} {to} ${this.$t('tables.general.of')} {count} ${this.$t('tables.general.records')}|{count} ${this.$t('tables.general.records')}|${this.$t('tables.general.oneRecord')}`,
            // first: 'First',
            // last: 'Last',
            filter: '',
            filterPlaceholder: this.$t('tables.general.searchQuery'),
            limit: this.$t('tables.general.records'),
            limitPlaceholder: this.$t('tables.general.records'),
            page: this.$t('tables.general.page'),
            noResults: this.$t('tables.general.noMatchingRecords'),
            filterBy: `${this.$t('tables.general.filterBy')} {column}`,
            loading: this.$t('tables.general.loading'),
            defaultOption: `${this.$t('tables.general.select')} {column}`,
            columns: this.$t('tables.general.columns')
          },

          sortable: _.without(this.tcols, 'actions', 'select'),

          // datepickerOptions: {
          //   showDropdowns: true,
          //   autoUpdateInput: true,
          // },

          columnsClasses: {
            id: 'id',
            actions: 'actions'
          },
          pagination: {
            chunk: 10,
            dropdown: false,
            nav: 'scroll'
          },

          filterable: !this.readonly,
          customFilters: [],

          sortIcon: {
            base: 'fontawesome',
            up: 'fa fa-chevron-up',
            down: 'fa fa-chevron-down',
            is: 'fa fa-sort'
          },

        },
        newRow: false,
        newRowData: {},
        selectedCustomFilter: '',
        previewOrderList: [],
        ordersPreviewUrl: [],
        isCustomFilter: false,
        editRow: '',
        inRowEdit: '',
        checked: [],
        dateFilter: false,
        nextUrl: window.location.href,
        isAdmin: '',
        isManagement: '',
        insType: [
          {key: '1', value: 'חובה'},
          {key: '2', value: 'מקיף'},
          {key: '3', value: 'צד ג'},
        ],
        companiesList: [
          {key: '1', value: 'ש.שלמה'},
          {key: '2', value: 'כלל'},
          {key: '3', value: 'מנורה'},
        ],
        msg: {
          msgType: 'email',
          messageId: '',
          address: '',
          phoneBookAddress: '',
          subject: '',
          content: '',
          files: [],
          isEditable: '',
          secondMailAddress: '',
        },
        phoneBook: [],
        campaignMessages: [],
        rolesSelected: '',
        campaignKind: '',
        openStatusCampaign: false,
      }
    },
    watch: {
      search_in_db: function(val){
        if(!val){
          this.updateUrl('dbSearch', '');
          this.$route.query.dbSearch = '';
        }
      },

    },
    methods: {
      getTableName() {
        if (this.tconfig && this.tconfig.tableName) {
          return this.tconfig.tableName;
        }
        const ordersPages = ['orders', 'ordersControl', 'ordersProtect', 'ordersCancellations', 'ordersCollection', 'ordersTasks', 'ordersClaims'];
        return ordersPages.includes(this.$route.name) ? 'orders' : this.$route.name;
      },
      routePartOfOrdersGroup() {
        let ordersPages = ['orders', 'ordersControl', 'ordersProtect', 'ordersCancellations', 'ordersCollection', 'ordersTasks', 'ordersClaims']
        return ordersPages.includes(this.$route.name);
      },
      db_search(){

      },
      updateInput(event) {

      },
      update_url_params(obj){
        let params = '';
        console.log(obj);
        if(typeof obj === 'object' && obj !== null) {
          for (const [key, value] of Object.entries(obj)) {
            if (value && key !== 'page') {
              params += '&' + key + '=' + value;
            }
          }
          this.url_params = params;
         console.log('params_leads', params);
        }
      },
      getAll() {
        axios.get(`/${this.$route.name}/all`)
          .then((res) => {
            // remove loader
            this.dataTableReady = false;
            this.rows = res.data.data.rows;
            this.rows = res.data.data.rows;
            let options = res.data.data.options;
            if (options) {
              for (let i in options) {
                this[i] = options[i]
              }
            }
          })
          .catch((err) => {
            // remove loader
            this.dataTableReady = false;
            this.$parent.$emit('alert', 'danger', err.response.data.status)
          })


      },
      updateUrl(key, val) {
        let uri = window.location.href
        let re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i')
        let separator = uri.indexOf('?') !== -1 ? '&' : '?'

        if (val instanceof Array) {
          val = val.join()
        }

        if (uri.match(re)) {

          uri = uri.replace(re, '$1' + key + '=' + val + '$2')
        } else {
          uri = uri + separator + key + '=' + val
        }
        window.history.pushState(null, null, uri)
        this.nextUrl = uri
      },
      closeRowEdit() {
        if (this.inRowEdit) {
          this.cancelEdit()
        }
      },

      downloadExcel_not(filename, event) {
        if (event) event.preventDefault();

        const input = prompt("כמה שורות אתה רוצה לייצא? השאר ריק לכולם:");
        const limit = parseInt(input);

        const dataToExport = isNaN(limit) ? this.allRows : this.allRows.slice(0, limit);

        if (!dataToExport || dataToExport.length === 0) {
          //alert("אין נתונים לייצוא.");
          return;
        }

        const headers = this.columns.filter(col => col !== 'actions');

        const rowsForSheet = dataToExport.map(row => {
          const filteredRow = {};
          headers.forEach(header => {
            filteredRow[header] = row[header];
          });
          return filteredRow;
        });

        const worksheet = XLSX.utils.json_to_sheet(rowsForSheet);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

        // הקובץ יורד בשם הרצוי
        XLSX.writeFile(workbook, `${filename}.xlsx`);

      },

      // Download table view to excel
      downloadExcel_1(filename) {
        let csv = [];
        let rows = document.querySelectorAll("table tr");

        for (let i = 0; i < rows.length; i++) {
          let row = [], cols = rows[i].querySelectorAll("td, th");

          for (let j = 0; j < cols.length; j++)
            row.push(cols[j].innerText);

          csv.push(row.join(","));
        }


        // Download CSV file
        this.downloadCSV(csv.join("\n"), filename);
      },

      downloadCSV(csv, filename) {
        let csvFile;
        let downloadLink;

        // CSV file
        csvFile = new Blob([csv], {type: "text/csv"});
        // Download link
        downloadLink = document.createElement("a");
        // File name
        downloadLink.download = filename;
        // Create a link to the file
        downloadLink.href = window.URL.createObjectURL(csvFile);
        // Hide download link
        downloadLink.style.display = "none";
        // Add the link to DOM
        document.body.appendChild(downloadLink);
        // Click download link
        downloadLink.click();
      },

      handleFilter() {
        if (this.options.filterByColumn) {
          this.options.filterByColumn = false
          delete this.options.filterable
          this.$refs.table.setFilter('')
        } else {
          this.options.filterByColumn = true
          this.options.filterable = this.tconfig.filters
          let tfiltersToObject = {}
          for (let i in this.tconfig.filters) {
            tfiltersToObject[this.tconfig.filters[i]] = ''
          }
          this.$refs.table.setFilter(tfiltersToObject)
        }

      },

      // Handle Statuses Filter
      setStatusesFilter() {
        let s = '';
        switch (this.$route.name) {
          case 'ordersControl' :
            s = 'lackOfClaims'
            break;
          case 'ordersProtect' :
            s = 'protectionStatus'
            break;
          case 'ordersCancellations' :
            s = 'policyStatus'
            break;
          case 'ordersCollection' :
            s = 'paymentStatus'
            break;
          case 'ordersTasks' :
            s = 'changesStatus'
            break;
          case 'ordersClaims' :
            s = 'claimsStatus'
            break;
          default :
            s = 'statuses';

        }
        let statusesFilter = [];
        let campaignStatusesFilter = [];
        let statuses = this.tconfig.options[s];

        for (let i in statuses) {
          if (statuses[i].statusGroup === this.tconfig.statusGroup || statuses[i].statusGroup === 0) {
            campaignStatusesFilter.push(statuses[i])
          }
          if (statuses[i].isShowStatus) {
            if (statuses[i].statusGroup === this.tconfig.statusGroup || statuses[i].statusGroup === 0) {
              statusesFilter.push(statuses[i])
            }
          }
        }
        this.statusesFilter = statusesFilter;
        this.campaignStatuses = campaignStatusesFilter;
      },

      setStatuses(statuses) {
        this.setStatusesFilter();
        let arr = [];
        for (let i in statuses) {
          if (statuses[i].statusGroup === this.tconfig.statusGroup || statuses[i].statusGroup === 0) {
            arr.push(statuses[i])
          }
        }
        return arr;
        // return this.tconfig.options[item] ? this.tconfig.options[item] : item
      },
      getFieldOptions(itemOptions) {
        if (itemOptions === 'statuses') {
          return this.statuses
        } else {
          return this.tconfig.options[itemOptions] ? this.tconfig.options[itemOptions] : itemOptions
        }
      },
      /* Handle Selected Filter */
      filterInsuranceCompany(e, filter) {
        let table = this.$refs.table
        this.dataTableReady = true;
        if (filter) {
          switch (filter) {
            case 'insTypeStatus':
              this.updateUrl('ins_type', this.$refs.insTypeStatus.value);
              this.$route.query['ins_type'] = this.$refs.insTypeStatus.value === 'all' ? this.clearSelectedFilter('insTypeStatus') : this.$refs.insTypeStatus.value;
              break;
            case 'companiesStatus':
              this.updateUrl('company', this.$refs.companiesStatus.value);
              this.$route.query['company'] = this.$refs.companiesStatus.value === 'all' ? this.clearSelectedFilter('companiesStatus') : this.$refs.companiesStatus.value;
              break;
            case 'paymentStatus':
              this.updateUrl('paymentStatus', this.$refs.paymentStatus.value);
              this.$route.query['paymentStatus'] = this.$refs.paymentStatus.value === 'all' ? this.clearSelectedFilter('paymentStatus') : this.$refs.paymentStatus.value;
              break;
            case 'policyStatus':
              this.updateUrl('policyStatus', this.$refs.policyStatus.value);
              this.$route.query['policyStatus'] = this.$refs.policyStatus.value === 'all' ? this.clearSelectedFilter('policyStatus') : this.$refs.policyStatus.value;
              break;
            case 'changesStatus':
              this.updateUrl('changesStatus', this.$refs.changesStatus.value);
              this.$route.query['changesStatus'] = this.$refs.changesStatus.value === 'all' ? this.clearSelectedFilter('changesStatus') : this.$refs.changesStatus.value;
              break;
            case 'claimsStatus':
              this.updateUrl('claimsStatus', this.$refs.claimsStatus.value);
              this.$route.query['claimsStatus'] = this.$refs.claimsStatus.value === 'all' ? this.clearSelectedFilter('claimsStatus') : this.$refs.claimsStatus.value;
              break;
            case 'protectiveStatus':
              this.updateUrl('protective_status', this.$refs.protectiveStatus.value);
              this.$route.query['protective_status'] = this.$refs.protectiveStatus.value === 'all' ? this.clearSelectedFilter('protectiveStatus') : this.$refs.protectiveStatus.value;
              break;
            case 'lackOfClaims':
              this.updateUrl('lack_of_claims', this.$refs.lackOfClaims.value);
              this.$route.query['lack_of_claims'] = this.$refs.lackOfClaims.value === 'all' ? this.clearSelectedFilter('lackOfClaims') : this.$refs.lackOfClaims.value;
              break;
            case 'dbSearch':
              this.updateUrl('dbSearch', this.search_in_db);
              this.$route.query['dbSearch'] = this.search_in_db ? this.search_in_db : '';
              break;
            case 'statusId':
              this.updateUrl('statusId', this.status_id);
              this.$route.query['statusId'] = this.status_id ? this.status_id : '';
              break;
            case 'orders':
              this.updateUrl('statusId', this.status_id);
              this.$route.query['statusId'] = this.status_id ? this.status_id : '';
              break;
            case 'ordersControl':
              this.updateUrl('ordersControl', this.status_id);
              this.$route.query['lack_of_claims'] = this.status_id ? this.status_id : '';
              break;
            case 'ordersProtect':
              this.updateUrl('ordersProtect', this.status_id);
              this.$route.query['protectiveStatus'] = this.status_id ? this.status_id : '';
              break;
            case 'ordersCancellations':
              this.updateUrl('ordersCancellations', this.status_id);
              this.$route.query['policyStatus'] = this.status_id ? this.status_id : '';
              break;
            case 'ordersCollection':
              this.updateUrl('ordersCollection', this.status_id);
              this.$route.query['paymentStatus'] = this.status_id ? this.status_id : '';
              break;
            case 'ordersTasks':
              this.updateUrl('ordersTasks', this.status_id);
              this.$route.query['changesStatus'] = this.status_id ? this.status_id : '';
              break;
            case 'ordersClaims':
              this.updateUrl('ordersClaims', this.status_id);
              this.$route.query['claimsStatus'] = this.status_id ? this.status_id : '';
              break;


          }

          let data = this.$route.query;


          if(!data.pages_chunk || parseInt(data.pages_chunk) === 0){
            data.pages_chunk = '25';
          }

          let url_page = '';
          if(data.page){
            url_page = "/" + data.page;
          }else{
            url_page = "/1";
          }

          /*let paramsData = {};*/

          /*paramsData.statusId = this.status_id;
          paramsData.routeName = this.$route.name;
          paramsData.pages_chunk = 25;*/

          let ordersPages = this.routePartOfOrdersGroup();
          let routeName = ordersPages ? 'orders' : this.$route.name ;

          if (data) {
            axios.post(`/${routeName}/insuranceCompanyFilter`, data)
              .then((res) => {
                if (res.data.data.rows) {
                  this.dataTableReady = false;
                  this.dateFilter = true;
                  this.rows = res.data.data.rows;
                  this.update_url_params(this.$route.query);
                  if ('total_rows' in res.data.data.options) {
                    this.rows_count = res.data.data.options.total_rows;
                  }
                } else {
                  this.$parent.$emit('alert', 'danger', 'No rows found')
                }
              })
              .catch((err) => {
                this.dataTableReady = false;
                this.$parent.$emit('alert', 'danger', err.response.data.data.error)
            })
          }

        }

      },

      clearSelectedFilter(filter) {
        switch (filter) {
          case 'insTypeStatus':
            this.updateUrl('ins_type', '');
            break;
          case 'companiesStatus':
            this.updateUrl('company', '');
            break;
          case 'protectiveStatus':
            this.updateUrl('protective_status', '');
            break;
          default:
            this.updateUrl('lack_of_claims', '');
        }

        //this.rows = this.trows;
      },

      /* Filter Hova And Company */
      searchHoveAndSecondCompany(e) {
        this.dataTableReady = true;
        if (e.target.value.length > 1) {
          this.updateUrl('hova_company', e.target.value);
          this.$route.query['hova_company'] =e.target.value;
          this.searchHoveAndSecondCompanyParam = e.target.value;
          let data = {
            ...this.$route.query,
            name: e.target.value
          };
          axios.post(`/${this.$route.name}/insuranceCompanyFilter`, data)
            .then((res) => {
              if (res.data.data.rows) {
                this.dataTableReady = false;
                this.rows = res.data.data.rows;
              } else {
                this.$parent.$emit('alert', 'danger', 'No rows found')
              }
            })
            .catch((err) => {
              this.dataTableReady = false;
              this.$parent.$emit('alert', 'danger', err.response.data.data.error)
            })
        } else {
          this.updateUrl('hova_company', e.target.value);
          this.getAll();
        }
      },
      filterLeadsStatuses(e) {
        this.dataTableReady = true;
        if (e.target.value !== 'all') {
          let data = {
            ...this.$route.query,
            statusId: e.target.value
          };
          let that = this;
          axios.post(`/${this.$route.name}/leadsStatusesFilter`, data)
            .then((res) => {
              if (res.data.data.rows) {
                that.rows = res.data.data.rows;
                that.dataTableReady = false;
              } else {
                that.$parent.$emit('alert', 'danger', 'No rows found')
              }
            })
            .catch((err) => {
              that.dataTableReady = false;
              this.$parent.$emit('alert', 'danger', err.response.data.data.error)
            })
        } else {
          this.rows = this.trows;
        }
      },

      cleanFilters() {
        this.dataTableReady = true;
        // Clear the statuses
        this.doCustomFilter('statusId', '');
        // Clear the columns;
        this.$refs.table.setOrder('', false);
        // Clean all data
        this.getAll();

        this.$refs.companiesStatus.value = 'all';
        this.$refs.insTypeStatus.value = 'all';
        this.$refs.lackOfClaims.value = 'all';
        this.$refs.protectiveStatus.value = 'all';

        // clean ins_type from the url
        if (this.$route.query['ins_type']) {
          this.$route.query['ins_type'] = '';
          this.updateUrl('ins_type', '');
        }
        // clean company from the url
        if (this.$route.query['company']) {
          this.$route.query['company'] = '';
          this.updateUrl('company', '');
        }
        // clean lack_of_claims from the url
        if (this.$route.query['lack_of_claims']) {
          this.$route.query['lack_of_claims'] = '';
          this.updateUrl('lack_of_claims', '');
          //  this.rows = this.trows
        }
        // clean protective_status from the url
        if (this.$route.query['protective_status']) {
          this.$route.query['protective_status'] = '';
          this.updateUrl('protective_status', '');
        }
        // clean hova_company from the url
        this.updateUrl('hova_company', '');
        $('#searchHoveAndSecondCompany').val('');
        // clear the searchBox
        if (this.options.filterBySearchBox && this.options.filterBySearchBox.length > 0) {
          this.$refs.table.query = '';
          this.updateUrl('tquery', '');
        }
      },
      selectAll (e) {
        let tmp = [];
        for (let row in this.rows) {
          let id = this.rows[row]['id'];
          let mobilePhone = this.rows[row]['mobile-phone-number'];
          let name = 'preview-order-list_'+id
          let productSelectedRow = this.rows[row]


          $('#'+name).prop('checked', event.target.checked);

          if(event.target.checked) {
            let checked = {
              "id": id,
              "mobilePhone": mobilePhone,
              "rowInfo": productSelectedRow
            };
            tmp.push(checked);
          }
        }

        this.previewOrderList = event.target.checked ? tmp : [];
      },

      catchPreviewList(mobilePhoneNumber, productSelectedRow) {

        let tmp = [];
        $("input[name='preview-order-list']").each(function () {
          if ($(this).is(':checked')) {
            let checked = {
              "id": ($(this).val()),
              "mobilePhone": mobilePhoneNumber,
              "rowInfo": productSelectedRow
            };
            tmp.push(checked);
          }
        });
        this.previewOrderList = tmp;
      },
      openOrderModal() {
        let hostname = window.location.hostname;
        let baseHostName = hostname === 'localhost' ? 'http://localhost:8080' : 'http://' + hostname;
        let ordersPreviewUrl = [];
        for (let orderId in this.previewOrderList) {
          ordersPreviewUrl[orderId] = `${baseHostName}/view?table=orders&id=${this.previewOrderList[orderId]["id"]}`;
        }
        this.ordersPreviewUrl = ordersPreviewUrl;
        setTimeout(() => {
          $('#order-preview-0').addClass('active');
        }, -1)
      },

      cleanModelCheck() {
        //this.previewOrderList = [];
        $("input[name='preview-order-list']").each(function (key) {
          if ($(this).is(':checked')) {
            $("input[name='preview-order-list']")[key].checked = false;
          }
        });
        this.previewOrderList = [];
      },
      openDateRange() {
        let that = this
        //http://www.daterangepicker.com/#options
        $('input[name="daterange"]').daterangepicker({
          'alwaysShowCalendars': true,
          opens: 'center',
          ranges: {
            'Today': [moment(), moment()],
            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
          },
          locale: {
            format: 'DD/MM/YY',
            'firstDay': 0
          }
        }).on('apply.daterangepicker', function (ev, picker) {
          that.getRecordsByDate(picker.startDate.format('YYYY-MM-DD'), picker.endDate.format('YYYY-MM-DD'))
        })
      },
      getRecordsByDate(startDate, endDate) {

        let data = {
          startDate: startDate,
          endDate: endDate
        }
        this.updateUrl('date', `${startDate},${endDate}`)

        axios.post(`/${this.$route.name}/dateFilter`, data)
          .then((res) => {
            if (res.data.data.rows) {
              this.dateFilter = true
              this.rows = res.data.data.rows
            } else {
              this.$parent.$emit('alert', 'danger', 'No rows found in the specified dates')
            }
          })
          .catch((err) => {
            this.$parent.$emit('alert', 'danger', err.response.data.data.error)
          })

      },

      clearDateFilter() {
        this.getAll()
        this.dateFilter = !this.dateFilter
        this.updateUrl('date', '')
        $('input[name="daterange"]').val('')
      },
      doCustomFilter(filterName, query) {
        // console.log(filterName, query)
        this.cancelEdit()

        if (this.selectedCustomFilter === query) {
          this.updateUrl('tcfilter', '');
          this.selectedCustomFilter = '';
          Event.$emit('vue-tables.filter::' + filterName, '');
          return
        }
        Event.$emit('vue-tables.filter::' + filterName, query);
        this.updateUrl('tcfilter', [filterName, query]);
        this.selectedCustomFilter = isNaN(query) ? query : parseInt(query);
        this.isCustomFilter = true
      },
      addNewRow(e) {

        // vee validate by scope
        this.$validator.validateAll(this.newRowData).then((result) => {
          if (result) {
            let data = {...this.newRowData}
            axios.post(`/${this.$route.name}/add`, data)
              .then((res) => {
                this.rows.push(res.data.data.row)
                this.$parent.$emit('alert', 'success', 'New record added to table')
                e.target.reset();
                // this.errors.clear()
                console.log(this.errors);

                this.getAll()
              })
              .catch((err) => {
                console.log(err)
                this.$parent.$emit('alert', 'danger', err.response.data.data.error)
              })

          }

        })

      },
      edit(e) {

        if (this.inRowEdit) {
          this.cancelEdit()
        }

        this.inRowEdit = e.id
        for (let item in this.tconfig.schema) {

          if (this.tconfig.schema[item].editable) {
            let el = this.$refs[e.id + '_' + this.tconfig.schema[item].name]
            if (el && el.length > 0) {
              el[0].children[0].classList.add('d-none')
              el[0].children[1].classList.remove('d-none')
            }
          }
        }

      },
      cancelEdit() {
        for (let item in this.tconfig.schema) {
          if (this.tconfig.schema[item].editable) {
            let el = this.$refs[this.inRowEdit + '_' + this.tconfig.schema[item].name]
            if (el && el.length > 0) {
              el[0].children[0].classList.remove('d-none')
              el[0].children[1].classList.add('d-none')
            }
          }
        }

        this.inRowEdit = ''
      },
      doneEdit(row) {
        this.$validator.validateAll(row).then((result) => {
          if (result) {
            let rawData = {...row}
            delete rawData['updated_at']
            delete rawData['created_at']
            delete rawData['id']
            let data = {'objectInfo': rawData};


            axios.post(`/${this.$route.name}/update/${row.id}`, data)
              .then((res) => {
                this.cancelEdit()

                // this.rows[rowId - 1] = res.data.data.row
                this.$parent.$emit('alert', 'success', 'Row updated')
                this.getAll()
              })
              .catch((err) => {
                this.$parent.$emit('alert', 'danger', err.response.data.data.error)
              })
          }
        })

      },
      view(e) {

        let obj = {
          table: this.$route.name,
          id: e.id,
        }

        if (e['first-name'] && e['last-name']) {
          obj.name = `${e['first-name']} ${e['last-name']}`
        }

        router.push({
          path: 'view', query: obj
        })
      },
      remove(id) {

        Swal.fire({
          title: 'Are you sure?',
          confirmButtonText: 'Yes',
          showCancelButton: true,
          cancelButtonText: 'No',
        }).then((result) => {

          if (result.value) {

            axios.post(`/${this.$route.name}/remove/${id}`, '')
              .then((res) => {
                // this.rows.splice((rowId - 1), 1)
                this.$parent.$emit('alert', 'success', 'Row deleted')
                this.getAll()
              })
              .catch((err) => {
                this.$parent.$emit('alert', 'danger', err.response.data.data.error)
              })

          }
        })

      },
      resendOrderToHova(row) {
        Swal.fire({
          title: 'לשלוח את ההזמנה הזו ל-CRM של חובה?',
          confirmButtonText: 'כן',
          showCancelButton: true,
          cancelButtonText: 'ביטול',
        }).then((result) => {
          if (!result.value) {
            return;
          }

          axios.post(`${this.getTableName()}/resendToHova/${row.id}`)
            .then((res) => {
              this.$parent.$emit('alert', 'success', 'ins_order: ' + res.data.data.ins_order)
            })
            .catch((err) => {
              this.$parent.$emit('alert', 'danger', (err.response && err.response.data && err.response.data.data && err.response.data.data.error) || 'שגיאה')
            })
        })
      },
      uploadCsv(e) {
        let file = e.target.files[0]

        Swal.fire({
          title: 'Are you sure?',
          confirmButtonText: 'Yes',
          showCancelButton: true,
          cancelButtonText: 'No',
        }).then((result) => {

          if (result.value) {

            let data = {
              file: file,
              isEmptyTable: false // TODO: add checkbox on SWAL
            }

            axios.post(`/${this.$route.name}/csvFile`, data)
              .then((res) => {
                this.$parent.$emit('alert', 'success', 'File uploaded')
                this.getAll()
              })
              .catch((err) => {
                this.$parent.$emit('alert', 'danger', err.response.data.data.error)
              })

          }
        })

      },
      print() {
        let table = document.querySelector('.VueTables__table');
        let tableClone = table.cloneNode(true);
        let tableInputs = tableClone.querySelectorAll('input, select');
        for (let i = 0; i < tableInputs.length; i++) {
          tableInputs[i].remove()
        }
        if (this.columns.includes('actions')) {
          let allRows = tableClone.rows;
          for (let i = 0; i < allRows.length; i++) {
            allRows[i].deleteCell(-1)
          }
        }

        tableClone.setAttribute('border', 1);
        let newWin = window.open('')
        newWin.document.write(tableClone.outerHTML)
        newWin.document.dir = 'rtl'

        newWin.print()
        newWin.close()
      },
      translateById(id, sourceData) {
        if (this[sourceData]) {
          for (let i in this[sourceData]) {
            if (this[sourceData][i].key == id) {
              if (this[sourceData][i]['color']) {
                return `<span class="badge badge-pill px-2" style="border: ${this[sourceData][i].color} solid 2px; color: #333;">${this[sourceData][i].value}</span>`
              } else {
                return `<span class="badge badge-pill text-white bg-color-6 px-2" >${this[sourceData][i].value}</span>`
              }
            }
          }
        } else {
          for (let i in sourceData) {
            if (sourceData[i].key === id) {
              return `<span>${sourceData[i].value}</span>`
            }
          }
        }
      },
      checkActionsLimitations(action) {
        let limitations = this.tconfig.actionsLimit;

        if (limitations) {
          if (limitations[action]) {
            switch (limitations[action]) {
              case 'all':
                return true;
                break
              case 'admin':
                return this.$store.getters.isAdmin;
                break;
              case 'management':
                return this.$store.getters.isManagement;
                break
              default:
                return true
            }
          }
        } else {
          return true
        }
      },
      requestMsg() {
        let id = this.$refs.msgType.value;
        for (let i in this.messages) {
          if (id === 'הודעה חדשה') {
            this.msg.address = ' ';
            this.msg.subject = ' ';
            this.msg.content = ' ';
            this.msg.replayTo = ' ';
            this.msg.isEditable = false;
            this.msg.autoSend = 0
          }

          if (this.messages[i].id === parseInt(id)) {

            this.msg.messageId = parseInt(id)
            this.msg.address = this.messages[i].address;
            this.msg.secondMailAddress = this.messages[i].secondMailAddress;
            this.msg.subject = this.messages[i].subject;
            this.msg.content = this.messages[i].content;
            this.msg.replayTo = this.messages[i].replayTo;
            this.msg.isEditable = this.messages[i].isEditable ? true : false;
            this.msg.autoSend = this.messages[i].autoSend ? this.messages[i].autoSend : 0;
            this.msg.isSms = this.messages[i].isSms;
            this.msg.isWhatsapp = this.messages[i].isWhatsapp;
            this.msg.smsContent = this.messages[i].smsContent;
          }
        }
      },

      sendMsg(e) {
        // start loader
        this.dataTableReady = true;

        if (this.msg.phoneBookAddress) {
          this.msg.address = this.msg.phoneBookAddress ? this.msg.phoneBookAddress : this.msg.address;
        }

        let that = this;
        for (let orderId in this.previewOrderList) {
          // get the phone number of each order
          if (this.msg.autoSend) {
            this.msg.phone = this.msg.autoSend === 2 ? this.previewOrderList[orderId]["mobilePhone"] : ''
          }
          // get the id of each order
          //this.msg.messageId = this.previewOrderList[orderId]["id"];
          axios.post(`${this.$route.name}/sendMail/${this.previewOrderList[orderId]["id"]}`, this.msg)
            .then((res) => {
              this.dataTableReady = false;
              this.$emit('alert', 'success', 'Message sent');

              this.isButtonClicked = false;
              that.msg.messageId = '';
              that.msg.address = ' ';
              that.msg.subject = '';
              that.msg.content = '';
              that.msg.replayTo = ' ';
              that.msg.files = [];
              that.msg.secondMailAddress = ' ';

              $('.multiselect__tag').remove();
              // Close collapse after mail sent;
              document.getElementById('msg').classList.remove('show');
              document.getElementById('msg').classList.add('hide');

              this.appendData();
              this.$refs.msgType.selectedIndex = 0;
              this.dataReady = true
            }).catch((err) => {
            this.dataTableReady = false;
            this.isButtonClicked = false;
            this.$emit('alert', 'danger', err.response.data.status)
          })
        }
      },
      openCampaignModal(prefix) {
          if(!prefix) {
            console.log('prefix not found')
            return
          }
          this.dataTableReady = true;
          this.campaignKind = prefix;
          let that = this;

          axios.post(`${prefix}/all`)
            .then((res) => {
              that.dataTableReady = false;
              that.campaignMessages = res.data.data.rows;

              setTimeout(() => {
                let element = that.$refs.campaignMessagesModel.$el
                $(element).modal('show')
              }, 1000)
            }).catch((err) => {
            this.dataTableReady = false;
            this.$emit('alert', 'danger', err.response.data.status)
          })

        //let element = this.$refs.modal.$el
      },

      openCampaignStatusesModal(action) {
        let that = this;
        if(!action) {
          return;
        }
        this.openStatusCampaign = true;
        setTimeout(() => {
          let element = that.$refs.campaignStatusesModel.$el
          $(element).modal('show')
        }, 1000)


      },
      addNoteAfterStatusUpdate(res) {

        if(!res) {
          console.log('Error - can not update multi note');
        }

        for (let k in res) {
          let rowId = res[k]['row']['id'];
          //translate old value
          let msgContent = '';
          for (let i in this.statuses) {
            if (this.statuses[i].key == res[k]['oldStatusId']) {
              msgContent += this.statuses[i].value
            }
          }
          //translate new value
          for (let i in this.statuses) {
            if (this.statuses[i].key == res[k]['row']['statusId']) {
              msgContent += ' > ' + this.statuses[i].value
            }
          }

          const data = {
            subject: 'שינוי סטטוס',
            description: msgContent
          };

          //this.addNewNote(note, false, false, 'orderStatus');
          axios.post(`leads/addNote/${rowId}`, data)
        }

      },

    }
}
</script>
<style scoped>
.border {
  border: 1px solid;
}
</style>
